import React from 'react'

import '../scss/variables.scss'
import '../scss/reset.scss'
import './Supportaci.scss'
import NavbarLogo from '../components/NavbarLogo/NavbarLogo'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'
import Button from '../components/Button/Button'

/* ===IMGS=== */
import Image2 from '../assets/images/Image_2.svg'

function Supportaci() {
    const titleButton = "DONA"

    return (
        <>
            <Sidemenu path1="/" name1="Home" path2="/chi-siamo" name2="Chi Siamo" path3="/progetto" name3="Il Progetto" path4="/community" name4="Community" />
            <NavbarLogo />
            <main id="supportaci">
                <h1>Supportaci</h1>
                <div className="supportInfo">
                    <p>Sei <b>interessato</b> a questo progetto e 
                    vorresti collaborare al suo <b>sviluppo</b>?</p>

                    <p>In questa sezione potrai darci un 
                    piccolo <b>aiuto</b> per poter ampliare e <b>
                    migliorare</b> i nostri servizi</p>

                    <p>Inoltre otterrai un <b>posto speciale</b> nella 
                    sezione apposita per <b>ringraziarti</b> del
                    tuo <b>supporto</b>! </p>

                    <img src={Image2} className="Image2" alt="FadySupport" />

                    <a href="https://www.paypal.com/paypalme/fadyorg" target="_blank" rel="noopener noreferrer">
                        <Button title={titleButton} />
                    </a>
                </div>
            </main>
            <Footer />
        </>
    )
}

export default Supportaci
